module.exports = __webpack_public_path__ + "img/harmony.e7b5b09.svg";